$(document).on('click', '.b-ajax__navigation--prev .btn', function (e) {
  e.preventDefault();
  $('.fancybox-container.fancybox-is-open').fadeOut(300, function () {
    $(this).remove(); // Odstran� element po animaci
  });
});
